import { combineReducers } from 'redux'
import { createReducer } from 'redux-act'
import { createReducerAsync } from 'redux-act-async'

import { loadCompanyProfiles } from 'actions/profile'

import environment from 'reducers/environment'
import objects from 'reducers/objects'
import building from 'reducers/building'
import flats from 'reducers/flats'
import favorites from 'reducers/favorites'
import collections from 'reducers/collections'
import collection from 'reducers/collection'
import search from 'reducers/search'
import notification from 'reducers/notification'
import loginForms from 'reducers/loginForms'
import authentication from 'reducers/authentication'
import { profile, agentProfile } from 'reducers/profile'
import profiles from 'reducers/profiles'
import company from 'reducers/company'
import privacy from 'reducers/privacy'
import allNews from 'reducers/news'
import payments from 'reducers/payments'

import { reducer as form } from 'redux-form'

const rootReducer = combineReducers({
  authentication,
  objects,
  building,
  flats,
  favorites,
  collections,
  collection,
  environment,
  search,
  notification,
  loginForms,
  profile,
  agentProfile,
  company,
  profiles,
  privacy,
  allNews,
  payments,
  form, // redux-form
});

export default rootReducer;


export const createPaginationReducer = (action) => {
  const defaultsState = {
    loading: false,
    request: null,
    data: null,
    error: null,
    offset: 0,
    finished: false,
  }

  return createReducer({
    [action.request]: (state, payload) => ({
      ...state,
      request: payload,
      loading: true,
      error: null,
    }),
    [action.ok]: (state, payload) => ({
      ...state,
      loading: false,
      finished: payload.response.length < payload.request[0].limit,
      offset: state.offset + payload.request[0].limit,
      data: payload.request[0].offset === 0 ?
        payload.response :
        [...state.data, ...payload.response],
    }),
    [action.error]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
  }, defaultsState)
}



// WEBPACK FOOTER //
// ./src/reducers/index.js